import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage, Translate } from '../../../core';
import { IControlProps, InputNumber, MapProps } from '..';
import styles from './selectproveedores.module.scss';
import { AutoComplete, Button, Dialog, SelectButton } from '../../prime';
import API from '../../../services/api';
import { IProveedor } from '../../../services/api/entity/model';
import Alert from '../../alerts';
import { GridComponent, getDataFromArray, IPagination, Grid } from '../..';
import { IPaginatedResponse } from '../../../services/model';
import { ClienteProveedorEditOut } from '../../../model/clientes/ClienteProveedorEditOut';
import { ProveedorListOut } from '../../../model/productos';

const format = (window as any).format;
const DiccionaryKey = 'components/forms/cliente/selectproveedores';
/*
export interface ClienteProveedorEditOut {
  /** id del proveedor *
  id: number;

  //nombre?: string;

  /** comisión en % *
  comision?: number;
}
*/

interface IProps extends IControlProps<ClienteProveedorEditOut[]> {
  storage?: IDataStorage;

  comisionDefault?: number;
}

interface IState extends IControlProps<ClienteProveedorEditOut[]> {
  storage?: IDataStorage;
  /** Indica el mensaje de error si es que existe */
  validError?: string;

  /** comision por default */
  comisionDefault?: number;

  proveedores?: ProveedorListOut[];

  modal?: {
    filterSelected: string[];
  }
}

class Index extends React.Component<IProps, IState> {
  state : IState = { };
  grid : Grid | null = null;
    
  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    this.loadentities();
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name);
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.comisionDefault !== s?.comisionDefault) res.comisionDefault = p.comisionDefault;
    return MapProps(res, p, s);
  }
  loadentities = () => {
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);
    API.ProductosController().Proveedor().find({}).then(e => {
      Alert.reponse(e);
      this.setState({ proveedores: e.data })
    }).catch(ex => Alert.error(t("@Id#ErrorInesperado"), `${ex}`));
  }

  getSelected = (a: ProveedorListOut) => this.state.value?.find(p => p.idProveedor === a.id);

  getGridData = (pag?: IPagination | undefined, sort?: string | undefined, filters?: any) : Promise<IPaginatedResponse<IProveedor>> =>
    getDataFromArray(pag, sort, filters, this.state.proveedores, (rows) => {
      
      if (!!filters && !!filters["nombre"]) rows = rows.filter(row => new RegExp(filters["nombre"].value, 'i').test(row.nombre) );

      const si = this.state.modal?.filterSelected?.includes("si");
      const no = this.state.modal?.filterSelected?.includes("no");
      if (!si && no) rows = rows.filter(p => !this.getSelected(p));
      if (si && !no) rows = rows.filter(p => !!this.getSelected(p));

      return rows;
    })

  render() {
    const { validError, modal, proveedores } = this.state;
    const t = Translate.get(DiccionaryKey, this.state.storage?.languaje);
    let order = 0;

    console.log("selectproveedores", this.state.value)
    
    return <>
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
        {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
        <div className={`${styles.addons} p-inputgroup`}>
          {this.state.required && 
            <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
              <i className="pi pi-exclamation-circle" />
            </span>
          }
          <AutoComplete 
            value={this.state.value}
            field="nombre"
            multiple
            disabled={this.state.disabled}
            selectedItemTemplate={e => <div style={{fontSize:'0.8rem'}}>{proveedores?.find(p => p.id === e.idProveedor)?.nombre}</div>}
            onChange={(e) => this.change(e.value)}
            className={styles.input}
          />
          <Button 
            icon={this.state.disabled ? 'pi pi-eye' : 'pi pi-search'} 
            className="p-button-primary" 
            onClick={() => this.setState({ modal: { filterSelected: ["si","no"] } })} 
            tooltip={this.state.disabled ? t("Open.Ver.Tooltip") : t("Open.Editar.Tooltip")}
            tooltipOptions={{position:'top'}} 
          />
        </div>
        {validError && <span className={styles.errordesc}>{validError}</span>}
      </div>
      <Dialog 
        modal
        header={<><span className="fas fa-hand-holding-usd" /> {t(`Modal.Tab.Titulo`)}</>}
        style={{width: '70%'}}
        footer={
          <div style={{ fontSize: '.8em' }}>
            <Button icon="fas fa-broom" label={t("Modal.Limpiar")} className="p-button-secondary" onClick={() => this.change([])} tooltip={t("Modal.Limpiar.Tooltip")} tooltipOptions={{position:'top'}} />
            <Button icon="fas fa-check-double" label={t("Modal.SeleccionarTodo")} className="p-button-success" onClick={() => this.addAll()} tooltip={t("Modal.SeleccionarTodo.Tooltip")} tooltipOptions={{position:'top'}} />
            <div style={{ width: 50, height: 10, display: 'inline-flex' }} />
            <Button label={t('Modal.Cerrar')} className="p-button-secondary" onClick={() => this.setState({ modal: undefined })} tooltip={t('Modal.Cerrar.Tooltip')} tooltipOptions={{position:'top'}} />
          </div>
        }
        visible={!!modal} 
        dismissableMask
        onHide={() => this.setState({ modal: undefined })}
      >
        
        <GridComponent 
          name="component//cliente/selectproveedores"
          syncGrid={e => this.grid = e}
          data={this.getGridData}
          columns={[
            { order: +order, field: 'nombre', header: t('Modal.Grid.nombre'), sortable: true, filter: true, filterPlaceholder: t('Modal.Grid.nombre.Placeholder'),
              body: row => !!row.bajafecha ? <label style={{ color: 'var(--danger)', margin: 0 }}>{row.nombre}</label> : <>{row.nombre}</>,
              export: row => row.nombre
            },
            { order: +order, field: 'comision', header: t('Modal.Grid.comision'), sortable: false, filter: false, style:{ width: 200 },
              export: row => format(this.getSelected(row)?.comision, "$$"),
              body: (row:IProveedor) => <InputNumber 
                className={"p-inputtext-sm p-d-block p-mb-2 p-field"}
                style={{ width: "100%" }}
                required
                placeholder={t("Modal.Col.comision.Placeholder")} 
                value={this.getSelected(row)?.comision}
                min={0} max={100}
                onChange={(e) => {
                  if (this.state.value) {
                    let val = this.getSelected(row);
                    if (!val) {
                      val = { idProveedor:row.id, comision: e };
                      this.state.value.push(val);
                    }
                    if (val) val.comision = e;
                    this.change(this.state.value);
                  }
                }}
              />
            },
            { order: +order, field: 'selected', header: t('Modal.Grid.seleccionado'), sortable: false, filter: true, style:{ width: 150, textAlign: 'center' }, hideForExport: true,
              body:r => {
                const sel = !!this.getSelected(r);
                return <Button
                  className={`${sel ? 'p-button-primary' : 'p-button-secondary'}`}
                  style={{ padding: '0 10px 0 10px', width: 'auto' }}
                  label={sel ? t("Modal.Grid.seleccionado.si") : t("Modal.Grid.seleccionado.no")}
                  icon={sel ? 'fas fa-check' : 'fas fa-ban'}
                  disabled={this.state.disabled}
                  onClick={() => {
                    if (modal && !sel) this.change([ ...(this.state.value ?? []), ...[{ idProveedor: r.id, comision: this.state.comisionDefault }]])
                    if (modal && sel) this.change((this.state.value ?? []).filter(p => p.idProveedor !== r.idProveedor))
                  }}
                />
              }, 
              filterElement:
                <SelectButton
                  optionLabel="name" 
                  optionValue="value" 
                  multiple
                  value={this.state.modal?.filterSelected}
                  className="p-column-filter"
                  style={{ textAlign:'center'}}
                  tooltip={t('Modal.Grid.seleccionado.Tooltip')}
                  tooltipOptions={{position:'bottom'}}
                  options={[
                    { name: 'Seleccionado', value: "si", icon: 'fas fa-check' },
                    { name: 'No Seleccionado', value: "no", icon: 'fas fa-ban'}
                  ]}
                  itemTemplate={o => <i className={`${o.icon}`} style={{ fontSize: '1em', width: '1em'}} />}
                  onChange={(e) => { if (modal) {
                    modal.filterSelected = e.value;
                    this.setState({ modal }, () => this.grid?.refresh());
                  }}}
                />
            },
          ]}
        />
      </Dialog>
    </>;
  }

  addAll = () => {
    const { proveedores, value, comisionDefault } = this.state;
    if (value) {
      const selecteds = value?.map(p => p.id) ?? [];
      const adds = proveedores?.filter(p => !selecteds.includes(p.id)) ?? [];
      this.change([ ...value, ...adds.map(p => ({ id: p.id, nombre: p.nombre, comision: comisionDefault }))]);
    }
  }

  change = (value?: ClienteProveedorEditOut[]) : string | undefined => {
    const { onChange, validate, isValid } = this.props;

    value = [ ...(value ?? []) ];
    let error = this.validate(value);
    if (validate) error = validate(value);
    if (isValid) isValid(!error, error);
    
    this.setState({ validError: error });

    if (onChange) onChange(value, error);

    return error;
  }

  private validate = (value?: ClienteProveedorEditOut[]) : string | undefined => {
    const { required } = this.state;

    if (required && (value?.length ?? 0) < 1) return 'campo requerido';

    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
